<template>
  <div class="rgpd-container">
    <div class="rgpd-modal">
      <div class="title">{{ $t('rgpd.modalTitle') }}</div>
      <div
        v-for="(agreement, index) in legalAgreements"
        :key="index"
        class="agreement"
        :class="{ checked: legalAgreements[index].value }"
        :aria-checked="!!legalAgreements[index].value"
        tabindex="0"
        @click="
          e => {
            legalAgreements[index].value = !legalAgreements[index].value;
            e.currentTarget.blur();
          }
        "
        @keypress.enter="legalAgreements[index].value = !legalAgreements[index].value"
      >
        <div class="checkbox" :class="{ checked: legalAgreements[index].value }" :aria-checked="!!legalAgreements[index].value"></div>
        <label v-html="agreement.text"></label>
      </div>
      <button class="main-button" :class="{ disabled: legalAgreements.find(legal => !legal.value) }" @click="rgpdAgreed()">
        {{ $t('rgpd.continue') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      legalAgreements: [
        {
          text: this.$t('rgpd.cguvTextAgreement'),
          value: false,
        },
        {
          text: this.$t('rgpd.textAgreement'),
          value: false,
        },
      ],
    };
  },

  methods: {
    rgpdAgreed() {
      this.$emit('rgpdAgreed');
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.rgpd-container {
  position: fixed;
  background: rgba(#000, 0.4);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rgpd-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 16px;
  width: 680px;
  max-width: 80%;
  color: colors.$text-color;
  background: colors.$white-color;
  border-radius: 6px;
}

.title {
  font-size: 20px;
  color: colors.$main-color;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
}

:deep(.message) {
  font-size: 16px;
  color: colors.$text-color;
  text-align: center;

  b {
    font-weight: 600;
  }
}

.agreement {
  display: flex;
  margin-bottom: 24px;
  cursor: pointer;
  width: 100%;

  :deep(label) {
    color: colors.$text-color;
    font-size: 14px;
    transition: 0.3s ease;

    a {
      transition: 0.3s;
      text-decoration: underline;

      &:hover {
        color: colors.$main-color;
      }
    }
  }

  .checkbox {
    margin-right: 20px;
  }
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid colors.$border-color;
  margin-top: 56px;

  button {
    width: 48%;

    &.cancel {
      background: colors.$white-color;
      color: colors.$accent-color;
    }
  }
}

@media (min-width: responsive.$layout-breakpoint-large) {
  .rgpd-modal {
    padding: 80px 40px 40px;
  }

  .title {
    font-size: 28px;
    margin-bottom: 40px;
  }
}
</style>
